// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order[data-v-31bf4eec] {\n  border: 1px solid #F1F1F1;\n  padding: 10px;\n  border-radius: 5px;\n}\n.product[data-v-31bf4eec] {\n  border: 1px solid #F1F1F1;\n  padding: 10px;\n  border-radius: 5px;\n}\n.btn-invoice[data-v-31bf4eec] {\n  border: 1px solid #54AD32;\n  display: block;\n  color: #54AD32;\n  padding: 10px;\n  text-decoration: none;\n  text-align: center;\n  border-radius: 5px;\n}\n.bill-btns[data-v-31bf4eec] {\n  margin: 0 auto;\n  max-width: 400px;\n}", ""]);
// Exports
module.exports = exports;
